<template>
    <div class="main-box mh-a content-box procut-center-page">
        <div v-for="(item, idx) in product" :key="idx">
            <h3 class="title">{{ item.title }}</h3>
            <div class="product-box">
                <div class="product-item" v-for="(it, index ) in item.data" :key="index + '_' + idx">
                    <router-link :to="it.link" style="display: block;text-decoration: none;color: #333;">
                        <div class="hd">{{ it.app }}</div>
                        <div class="bd">
                            <div class="img">
                                <img :src="it.img" alt="">
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            product: [
                // {
                //     title: '智能系统',
                //     data: [
                //         {
                //             link: '',
                //             img: "/static/img/programme/c1.png",
                //             app: '智慧更衣区管理系统'
                //         },
                //         {
                //             link: '',
                //             img: "/static/img/programme/c2.jpg",
                //             app: '智慧车间管理系统'
                //         },
                //         {
                //             link: '',
                //             img: "/static/img/programme/c3.jpg",
                //             app: '智慧实验室管理系统'
                //         },

                //     ]
                // },
                {
                    title: '软件产品',
                    data: [
                        {
                            link: '/iristar-software?anchor=a0',
                            img: "/static/img/programme/2.png",
                            app: '人员管理系统'
                        },
                        {
                            link: 'iristar-software?anchor=a1',
                            img: "/static/img/programme/c5.jpg",
                            app: '洁净服全生命周期管理软件'
                        },
                        {
                            link: 'iristar-software?anchor=a2',
                            img: "/static/img/programme/c6.jpg",
                            app: '人员行为管理软件'
                        },
                        {
                            link: 'iristar-software?anchor=a3',
                            img: "/static/img/programme/c7.jpg",
                            app: '电子实验记录本（ELN)'
                        },

                        {
                            link: 'iristar-software?anchor=a4',
                            img: "/static/img/programme/9.png",
                            app: '人工智能算法平台'
                        },



                    ]
                },
                {
                    title: '智能硬件',
                    data: [
                        {
                            link: '/static/img/product/1.png',
                            img: "/static/img/programme/c8.png",
                            app: '混合生物特征识别一体机'
                        },
                        {
                            link: '/product-details/S260P',
                            img: "/static/img/product/5.png",
                            app: '驾驶员身份识别一体机'
                        },
                        {
                            link: '/product-details/S330B',
                            img: "/static/img/product/14.png",
                            app: '壁挂式虹膜人脸识别一体机'
                        },
                        {
                            link: '/product-details/S310',
                            img: "/static/img/product/S310.png",
                            app: '多模态虹膜人脸一体机'
                        },
                        {
                            link: '/product-details/W200',
                            img: "/static/img/product/9.png",
                            app: '手持式虹膜人脸信息采集设备'
                        },
                        {
                            link: '/product-details/S300-UC',
                            img: "/static/img/product/7.png",
                            app: '桌面式虹膜人脸信息采集设备'
                        },
                        {
                            link: '/product-details/AI视觉分析边缘计算盒子',
                            img: "/static/img/product/aibox.png",
                            app: 'AI视觉分析边缘计算盒子'
                        },
                        {
                            link: '/product-details/AI视觉分析服务器',
                            img: "/static/img/product/aianalyse.png",
                            app: 'AI视觉分析服务器'
                        },

                    ]
                }
            ]
        }
    }
};
</script>

<style lang="less" scoped>
.procut-center-page {
    padding: 20px;

    .title {
        font-size: 19px;
        margin-top: 20px;
    }

    .product-box {
        .hd {
            // text-align: center;
            font-size: 18px;
            margin: 20px 0;
        }
    }
}


@media (min-width: 768px) {


    .procut-center-page {
        .title {
            font-size: 19px;
            margin-top: 20px;
        }

        .product-box {
            display: flex;
            flex-wrap: wrap;

            .product-item {
                flex: 0 0 25%;
                padding: 20px;

                .hd {
                    text-align: center;
                    font-size: 18px;
                    margin: 20px 0;
                }

                .bd {
                    text-align: center;
                    font-size: 18px;
                    height: 0;
                    padding-bottom: 70%;
                    overflow: hidden;
                    position: relative;

                    .img {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }
                }
            }
        }
    }
}
</style>